import { Col, Row, Spin, Typography } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';

export default function Authenticating(): ReactElement {
  return (
    <div
      style={{
        height: 250,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <img src={`/shield-light.svg`} alt="shield" width={150} />
    </div>
  );
}
